import React, { useState } from 'react';

import LegalContent from '../../LegalModal/Content';

import * as Layout from '../styled';
import * as Styled from './styled';

import { BackNavigate } from '../Components/BackNavigate';

const LegalTerms = ({ active, onNext }) => {
  const [loading, setLoading] = useState(false);

  const onSubmitHandle = () => {
    setLoading(true);

    // No rush, take is slow, :D
    setTimeout(() => {
      onNext();
      setLoading(false);
    }, 350);
  }

  if (!active)
    return null;

  return (
    <Layout.Screen $terms>
      <BackNavigate to={`/`} alternative />

      <Styled.LegalWrapper>
        <LegalContent loading={loading} onSubmit={onSubmitHandle} />
      </Styled.LegalWrapper>
    </Layout.Screen>
  );
}

export default LegalTerms;
